import React from "react";
import BlockUi from "react-block-ui";
import { JdsTag } from "../../../components/jds/JdsTag";
import { Field } from "./clienteUi";

export default function BulkQueriesCard({ product, isLoading, onToggle }) {
  const enabled = product?.enabled;

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-5">
      <BlockUi tag="div" blocking={isLoading} style={{ height: "100%" }}>
        <div className="jds-card cd-product">
          <div className="cd-product-head">
            <h2 className="jds-title-md">Consulta em lote</h2>
          </div>

          <p className="text-muted mb-0">
            Habilita ou desabilita a consulta processual em lote para o cliente.
          </p>

          <div className="d-flex align-items-center justify-content-between">
            <Field label="Status">
              {/* label só reflete o enabled vindo do GET (fonte da verdade) */}
              <JdsTag
                dot
                color={enabled ? "success" : "error"}
                label={enabled ? "Habilitado" : "Desabilitado"}
              />
            </Field>

            {/* switch Metronic — checked = enabled; alternar chama onToggle(novoValor) */}
            <span className="switch switch-icon">
              <label>
                <input
                  type="checkbox"
                  checked={!!enabled}
                  disabled={isLoading}
                  onChange={(e) => onToggle(e.target.checked)}
                />
                <span></span>
              </label>
            </span>
          </div>
        </div>
      </BlockUi>
    </div>
  );
}
